import { Component, OnInit } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { version } from '../../../../package.json';
import { environment } from '../../../environments/environment';
import { env } from 'process';

@Component({
  selector: 'site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.css']
})
export class SiteFooterComponent implements OnInit {

  year: string;
  isSmallScreen: boolean = false;
  isMapVisible: boolean = false;
  version: string = version;
  prod = environment.production ? true : false;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private wgisservice: WgisService,
    ) 
  {
    this.year = new Date().getFullYear().toString();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible =  (mode !== WGisDisplayMode.Invisible);
    });
   }

  ngOnInit() {
      this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
      this.isMapVisible = this.wgisservice.getMapVisible();
  }

}